import promise from 'es6-promise';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
promise.polyfill();
import Vue from 'vue';
import App from './App.vue';
import router from './router'; //路由
import ElementUI from 'element-ui'; //el
import 'element-ui/lib/theme-chalk/index.css'; //el样式表
import store from '@/store'; //vuex
// import '@/assets/css/eduBase.css'; //基础样式表
import eventBus from '@/utils/eventBus_improve'; //消息组件
Vue.prototype.$eventBus = eventBus;
import windowSizeMixin from '@/mixins/windowSizeMixin'; //混入-浏览器窗口监听
import * as echarts from 'echarts'; // 在import的后面，echarts的前面加一个 * as
import './public/echarts-wordcloud.js';
Vue.prototype.$echarts = echarts;
Vue.mixin(windowSizeMixin);
Vue.use(ElementUI);

if (process.env.NODE_ENV === 'production') {
	if (window) {
		window.console.log = function () {};
	}
}
// 检测是否是 IE 浏览器
const isIE =
	/msie|trident/i.test(navigator.userAgent) &&
	!/opera/i.test(navigator.userAgent);
if (isIE) {
	// 	ElementUI.MessageBox.confirm(
	// 		'您的浏览器版本过低，建议使用新版本的浏览器如Chrome，Firefox，Edge等访问本网站。',
	// 		'浏览器不兼容',
	// 		{
	// 			confirmButtonText: '确认',
	// 			cancelButtonText: '下载其他浏览器',
	// 			type: 'warning',
	// 			showCancelButton: true,
	// 			closeOnClickModal: false,
	// 		}
	// 	)
	// 		.then(() => {
	// 			throw new Error('IE 浏览器不受支持，请使用新版本的浏览器访问。');
	// 			// window.location.href = 'www.baidu.com/';
	// 			// 用户选择继续使用，给出第二个提示
	// 			// ElementUI.MessageBox.alert(
	// 			// 	'您已确认继续使用旧版浏览器，但某些功能可能无法正常使用。',
	// 			// 	'警告',
	// 			// 	{
	// 			// 		confirmButtonText: '知道了',
	// 			// 	}
	// 			// ).then(() => {
	// 			// 	// 加载应用
	// 			// 	throw new Error(
	// 			// 		'IE 浏览器不受支持，请使用新版本的浏览器访问。'
	// 			// 	);
	// 			// 	// new Vue({
	// 			// 	// 	render: (h) => h(App),
	// 			// 	// 	router,
	// 			// 	// 	store,
	// 			// 	// }).$mount('#app');
	// 			// });
	// 		})
	// 		.catch(() => {
	// 			// 用户选择返回首页
	// 			window.open('http://www.baidu.com/');
	// 			// window.location.href = 'http://www.baidu.com/';
	// 		});
} else {
	// 如果不是 IE 浏览器，正常加载应用
	new Vue({
		render: (h) => h(App),
		router,
		store,
	}).$mount('#app');
}
